import classNames from "classnames";
import React from "react";
import { MdCheck } from "react-icons/md";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

function UpsellsCard({
  name,
  cost,
  currency,
  onAdd,
  notSelected,
  supportingInformation,
}) {
  const isSelected = !notSelected;

  return (
    <button
      type="button"
      className={classNames("miltis-upsells__card", {
        "miltis-upsells__card--selected": isSelected,
      })}
      onClick={onAdd}
    >
      <div className="miltis-upsells__card-content">
        {/* Checkbox */}
        <div
          className={classNames("miltis-upsells__checkbox", {
            "miltis-upsells__checkbox--selected": isSelected,
          })}
        >
          {isSelected && <MdCheck size={14} color="#fff" />}
        </div>

        {/* Main content */}
        <div className="miltis-upsells__card-main">
          {/* Header row with name and price */}
          <div className="miltis-upsells__card-header">
            <span className="miltis-upsells__card-name">{name}</span>
            <span className="miltis-upsells__card-price">
              {costToFrench(cost)} {CURRENCY_SYMBOL[currency] || "€"} / mois
            </span>
          </div>

          {/* Benefits list */}
          {supportingInformation && supportingInformation.length > 0 && (
            <div className="miltis-upsells__card-benefits">
              {supportingInformation
                .flatMap((item) => item.value || [])
                .map((benefit, index, array) => (
                  <React.Fragment key={index}>
                    <div className="miltis-upsells__benefit-row">
                      <span className="miltis-upsells__benefit-label">
                        {benefit.mainInfo}
                      </span>
                      <span className="miltis-upsells__benefit-value">
                        {benefit.description}
                      </span>
                    </div>
                    {index < array.length - 1 && (
                      <div className="miltis-upsells__benefit-divider" />
                    )}
                  </React.Fragment>
                ))}
            </div>
          )}
        </div>
      </div>
    </button>
  );
}

export default React.memo(UpsellsCard);
